import {
  DELIVERY_PLAN_LIST, 
  DELIVERY_PLAN_LIST_SUCCESS, 
  DELIVERY_PLAN_LIST_ERROR,
  DELIVERY_PLAN_SEARCH_SET, 
  DELIVERY_PLAN_SEARCH_CHANGE, 
  DELIVERY_PLAN_PAGE_SET,
  DELIVERY_PLAN_SEARCH_DELIVERY_ORDER_LINE_LOT,
  DELIVERY_PLAN_SEARCH_DELIVERY_ORDER_LINE_LOT_SUCCESS,
  DELIVERY_PLAN_SEARCH_DELIVERY_ORDER_LINE_LOT_ERROR,
  DELIVERY_PLAN_ADD_SET,
  DELIVERY_PLAN_ADD_MODAL_SET,
  DELIVERY_PLAN_ADD,
  DELIVERY_PLAN_ADD_SUCCESS,
  DELIVERY_PLAN_ADD_ERROR,
  DELIVERY_PLAN_ADD_CHANGE,
  DELIVERY_PLAN_DETAIL,
  DELIVERY_PLAN_DETAIL_SUCCESS,
  DELIVERY_PLAN_DETAIL_ERROR,
  DELIVERY_PLAN_VIEW_MODAL_SET,
  DELIVERY_PLAN_EDIT_CHANGE,
  DELIVERY_PLAN_EDIT_MODAL_SET,
  DELIVERY_PLAN_UPDATE,
  DELIVERY_PLAN_UPDATE_SUCCESS,
  DELIVERY_PLAN_UPDATE_ERROR,
  DELIVERY_PLAN_VIEW_TAB_SET,
  DELIVERY_PLAN_UPLOAD_SET,
  DELIVERY_PLAN_UPLOAD_SET_SUCCESS,
  DELIVERY_PLAN_UPLOAD_SET_ERROR,
  DELIVERY_PLAN_UPLOAD_RESET
} from '../actions';
 
const INIT_STATE = {
  loading: true,
  file: [],
  list: {
    header:{
      name: 'code',
      order:'sorted-asc'
    },
    page:{
      current: 1,
      rows: 100
    }
  },
  add: {
      data: {
        new:{ maintenance_flag: false, maintenance_delay_flag: false, event_date: null,  id_delivery_order_line_lot: null, delivery_order_line_lot: null, id_document_type: null}
      },
      modal: false,
      loading: false,
      message: '',
      url: '',
      type: ''
  },
  error: false,
  search:{
    modal: false,
    init:true,
    data:{
      delivery_order_line_lot: false
    },
    value:{
      delivery_order_line_lot: false,
    },
    delivery_order_line_lot:{
      loading: true,
      list:[],
      message: ''
    }
  },
  detail: {
    data: [],
    tab: 'general',
    loading: true,
  },
  view: {
    loading: true,
    data: [],
    tab: 'general',
    modal: false,
    log: {
      data: [],
      loading: false,
    },
  },
  edit: {
    loading: true,
    data: {
        new: [],
        old: []
    },
    list: {
        status: {
            data: [],
            loading: false,
        }
    },
    modal: false,
    update: {
        loading: false,
        response: '',
        message: ''
    }
  }
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case DELIVERY_PLAN_LIST:
      return {
        ...state,
        loading: true,
        list: {
          ...state.list
        }
        
      }
    case DELIVERY_PLAN_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        list: {
          ...state.list,
          ...action.payload
        } 
      }
    case DELIVERY_PLAN_LIST_ERROR:
      return {
        ...state,
        loading: false,
        error: true
      }
    case DELIVERY_PLAN_SEARCH_SET:
      return {
        ...state,
        search:{
          ...state.search,
          data: action.payload,
        }
      }
    case DELIVERY_PLAN_SEARCH_CHANGE:
      return {
        ...state,
        search:{
          ...state.search,
          value: action.payload,
        }
      }
    case DELIVERY_PLAN_PAGE_SET:
      return {
        ...state,
        list: {
          ...state.list,
          page: {
            ...state.list.page,
            ... action.payload,
          }
        },
        log: []
      }
    case DELIVERY_PLAN_SEARCH_DELIVERY_ORDER_LINE_LOT:
      return {
        ...state,
        search:{
          ...state.search,
          init:false,
          delivery_order_line_lot:{
            ...state.search.delivery_order_line_lot,
            loading: true,
            list:[],
            message: ''
          }
        }
      }
    case DELIVERY_PLAN_SEARCH_DELIVERY_ORDER_LINE_LOT_SUCCESS:
      return {
        ...state,
        search:{
          ...state.search,
          delivery_order_line_lot:{
            ...state.search.delivery_order_line_lot,
            loading: false,
            list: action.payload,
            message: ''
          }
        }
      }
    case DELIVERY_PLAN_SEARCH_DELIVERY_ORDER_LINE_LOT_ERROR:
      return {
        ...state,
        search:{
          ...state.search,
          delivery_order_line_lot:{
            ...state.search.delivery_order_line_lot,
            loading: false,
            list:[],
            message: 'No se encotraron datos'
          }
        }
      }
    case DELIVERY_PLAN_ADD_CHANGE:
      return {
        ...state,
        add: {
          ...state.add,
          data: {
            ...state.add.data,
            new: {
              ...state.add.data.new,
              ...action.payload
            }
          }
        }
      }
    case DELIVERY_PLAN_ADD_SET:
      return {
        ...state,
        add: {
          ...state.add,
          data: action.payload
        }
      }
    case DELIVERY_PLAN_ADD_MODAL_SET:
      return {
        ...state,
        add: {
          ...state.add,
          data: { 
            ...state.add.data,
            new:{ maintenance_flag: false, maintenance_delay_flag: false, event_date: null,  id_delivery_order_line_lot: null, delivery_order_line_lot: null, id_document_type: null}
          },
          modal: action.payload
        }
      }
    case DELIVERY_PLAN_ADD:
      return {
        ...state,
        add: {
          ...state.add, 
          loading: true
        }
      }
    case DELIVERY_PLAN_ADD_SUCCESS:
      return {
        ...state,
        add: {
          ...state.add,
          modal: false,
          loading: false,
          message: action.payload.message,
          id: action.payload.id
        }
      }
    case DELIVERY_PLAN_ADD_ERROR:
      return {
        ...state,
        add: {
          ...state.add,
          loading: false,
          message: action.payload.message
        }
      }
    case DELIVERY_PLAN_DETAIL:
      return {
        ...state,
        detail: {
          ...state.detail,
          loading: true,
          data: []
        }
      }
    case DELIVERY_PLAN_DETAIL_SUCCESS:
      return {
        ...state,
        detail: {
          ...state.detail,
          loading: false,
          ...action.payload
        },
        edit: {
          ...state.edit,
          loading: false,
          data: {
            new: action.payload.data,
            old: action.payload.data
          }
        }
      }
    case DELIVERY_PLAN_DETAIL_ERROR:
      return {
        ...state,
        detail: {
          ...state.detail,
          loading: false,
          data: []
        }
      }
    case DELIVERY_PLAN_VIEW_MODAL_SET:
      return {
        ...state,
        view: {
          ...state.view,
          modal: action.payload
        }
      }
    case DELIVERY_PLAN_EDIT_MODAL_SET:
      return {
        ...state,
        edit: {
          ...state.edit,
          modal: action.payload
        }
      }
    case DELIVERY_PLAN_EDIT_CHANGE:
      return {
        ...state,
        edit: {
          ...state.edit,
          data: {
            ...state.edit.data,
            new: {
              ...state.edit.data.new,
              ...action.payload
            }
          }
        }
      }
    case DELIVERY_PLAN_UPDATE:
      return {
        ...state,
        edit: {
          ...state.edit,
          data: {
            ...state.edit.data,
            ...action.payload,
          },
          update: {
            ...state.update,
            loading: true,
            response: '',
            message: ''
          }
        }
      }
    case DELIVERY_PLAN_UPDATE_SUCCESS:
      return {
        ...state,
        edit: { 
          ...state.edit,
          modal: false,
          data: {
            ...state.edit.data,
            new: {
              ...state.edit.data.new,
              update_reason: ''
            },
            old: {
              ...state.edit.data.new,
              update_reason: ''
            }
          },
          update: {
            ...state.update,
            loading: false,
            response: 'success',
            message: action.payload
          }
        },
        view: {
          ...state.view,
          modal: false
        }
      }
    case DELIVERY_PLAN_UPDATE_ERROR:
      return {
        ...state,
        edit: {
          ...state.edit,
          update: {
            ...state.update,
            loading: false,
            response: 'error',
            message: action.payload
          }
        }
      }
    case DELIVERY_PLAN_VIEW_TAB_SET:
      return {
        ...state,
        view: {
          ...state.view,
          tab: action.payload
        }
      }
    case DELIVERY_PLAN_UPLOAD_SET:
      return { ...state };
    case DELIVERY_PLAN_UPLOAD_SET_SUCCESS:
      return {
        ...state,
        file: [...state.file, action.payload]
      };
    case DELIVERY_PLAN_UPLOAD_SET_ERROR:
      return { 
        ...state,
        file: [...state.file, action.payload]
      };
    case DELIVERY_PLAN_UPLOAD_RESET:
      return {
        ...state,
        file: []
      };
    default:
      return { ...state };
    }

};